// extracted by mini-css-extract-plugin
module.exports = {"lds-ring":"loader_lds-ring__3v8FO"};